var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2224 3.37624C14.1874 2.34138 12.5095 2.34139 11.4746 3.37624L10.4312 4.41958C10.4279 4.42276 10.4246 4.42597 10.4213 4.42923C10.418 4.43249 10.4148 4.43577 10.4117 4.43908L2.78804 12.0622C2.66614 12.1841 2.59766 12.3494 2.59766 12.5218V16.7512C2.59766 16.9236 2.66614 17.0889 2.78804 17.2108C2.90995 17.3327 3.07528 17.4012 3.24768 17.4012L7.47737 17.4012C7.64976 17.4012 7.8151 17.3327 7.937 17.2108L16.6235 8.52484C17.6585 7.48999 17.6585 5.81216 16.6235 4.7773L15.2224 3.37624ZM10.881 5.80814L3.8977 12.791L3.8977 16.1012H7.20812L14.1915 9.11833L10.881 5.80814ZM15.1107 8.19913L15.7043 7.60563C16.2315 7.07844 16.2315 6.2237 15.7043 5.69651L14.3031 4.29544C13.7759 3.76826 12.9211 3.76826 12.3938 4.29545L11.8003 4.88894L15.1107 8.19913Z",
    fill: "#5E666E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.59dc29e5e86c93593189be8d7b7dceda.svg";
export { ForwardRef as ReactComponent };